export default __webpack_public_path__ + "static/media/hyde.f517524a.png";